__turbopack_context__.v({
  "className": "inter_260b4878-module__tbi_Kq__className",
});
